import {
  SET_ONBOARDER,
  REGISTER_SUCCESS,
  CLEAR_ONBOARDER,
  LOGIN_SUCCESS,
} from "./actiontypes";
import * as url from "../../constants/urls";
export const setOnboarder = (field, value) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_ONBOARDER, payload: [field, value] });
  };
};

const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = window.document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
export const register = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    //register request
    return fetch(url.signUpUrl, {
      method: "POST",
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          const { code, gender, mobile, token } = json;
          document.cookie = `token=${token}; path=/; domain=.devsaycheese.com;`;
          localStorage.setItem("token", token);
          dispatch({ type: CLEAR_ONBOARDER });
          dispatch({ type: REGISTER_SUCCESS, token: token });
          return { code, gender, mobile };
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const otpVerification = (data, type) => {
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().onboard.onboarder;
    //otp verification request
    return fetch(url.mobileVerificationUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          dispatch({
            type: SET_ONBOARDER,
            payload: ["mobileVerified", true],
          });
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const otpVerificationWW = (data, type) => {
  // let myUrl;
  // if (type === "email") myUrl = url.emailVerificationUrl;
  // else myUrl = url.mobileVerificationUrl;
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }

  return (dispatch, getState) => {
    const { otpToken } = getState().onboard.onboarder;
    //otp verification request
    return fetch(url.mobileOtpVerify, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${otpToken}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          dispatch({
            type: SET_ONBOARDER,
            payload: ["mobileVerified", true],
          });
          return json;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const sendOtp = (data) => {
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }

  return (dispatch, getState) => {
    const { token } = getState().onboard.onboarder;
    //otp verification request
    return fetch(url.mobileOtpUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          dispatch({
            type: SET_ONBOARDER,
            payload: ["otpToken", json.token],
          });
          return true;
        } else {
          // throw Error(json.message);
          return { error: json.message };
        }
      });
  };
};

export const genderVerification = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().onboard.onboarder;
    //otp verification request
    fetch(url.genderUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          dispatch({ type: SET_ONBOARDER, payload: ["gender", data.gender] });
        }
        if (json.code === -2) {
          dispatch({ type: SET_ONBOARDER, payload: ["gender", "Female"] });

          dispatch({
            type: SET_ONBOARDER,
            payload: ["coins", 25],
          });
        }
        if (json.code === -4) {
          dispatch({ type: SET_ONBOARDER, payload: ["gender", "Male"] });
        }
      })
      .catch((e) => alert(e.message));
  };
};

export const setPassword = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    if (data[key] === "") continue;
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().onboard.onboarder;
    //otp verification request
    return fetch(url.setPasswordUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          dispatch({ type: SET_ONBOARDER, payload: ["password", true] });
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const submitWWForm = (data) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    const { token } = getState().onboard.onboarder;
    //otp verification request
    return fetch(url.wwFormUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          const { token, type } = json;
          document.cookie = `user_type=${type}; path=/; domain=.devsaycheese.com;`;
          document.cookie = `token=${token}; path=/; domain=.devsaycheese.com;`;
          localStorage.setItem("utoken", token);
          localStorage.setItem("utype", type);
          const redirectToUrl = getCookie("redirectURL");
          if (
            redirectToUrl &&
            redirectToUrl != null &&
            redirectToUrl.replace(/\s+/g, "") != ""
          ) {
            document.cookie =
              "redirectURL=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.devsaycheese.com;";
            window.location.href = redirectToUrl;
            return;
          }
          dispatch({ type: LOGIN_SUCCESS, user: { token, type } });
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const submitGiverForm = (data, from) => {
  //converting object to formdata
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }
  return (dispatch, getState) => {
    let token;
    if (from === "seeker") {
      token = getState().user.user.token;
    } else {
      token = getState().onboard.onboarder.token;
    }
    //otp verification request
    return fetch(url.giverFormUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form_data,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return true;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const clearOnboarder = () => {
  return (dispatch, getState) => {
    localStorage.removeItem("token");
    dispatch({ type: CLEAR_ONBOARDER });
  };
};

export const getOnBoardingData = () => (dispatch, getState) => {
  const tkn = localStorage.getItem("token");
  fetch(url.getOnBoardingData, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${tkn}`,
    },
  })
    .then((res) => res.json())
    .then((json) => {
      const {
        step,
        code,
        email,
        mobile,
        gender,
        mobileverified,
        indian,
        countrycode,
        gsign,
        token,
        age,
        message,
        ecomm_status,
      } = json;

      if (message == "Giver Onboarding Completed") {
        dispatch({
          type: SET_ONBOARDER,
          payload: ["completed", true],
        });
      } else {
        dispatch({
          type: SET_ONBOARDER,
          payload: ["completed", false],
        });
      }
      if (code === 3) {
        dispatch({
          type: SET_ONBOARDER,
          payload: ["femaleGiver", true],
        });
        dispatch({
          type: SET_ONBOARDER,
          payload: ["accountCreated", true],
        });
      } else {
        dispatch({
          type: SET_ONBOARDER,
          payload: ["femaleGiver", false],
        });
      }
      if (mobile) {
        dispatch({
          type: SET_ONBOARDER,
          payload: ["mobile", mobile],
        });

        dispatch({
          type: SET_ONBOARDER,
          payload: ["mobileVerified", mobileverified],
        });
        dispatch({
          type: SET_ONBOARDER,
          payload: ["indian", indian],
        });
        dispatch({
          type: SET_ONBOARDER,
          payload: ["countrycode", countrycode],
        });
      }

      if (email) {
        dispatch({
          type: SET_ONBOARDER,
          payload: ["email", email],
        });
        dispatch({
          type: SET_ONBOARDER,
          payload: ["emailVerified", true],
        });
        dispatch({
          type: SET_ONBOARDER,
          payload: ["gsign", gsign],
        });
      }

      if (step === 4) {
        dispatch({
          type: SET_ONBOARDER,
          payload: ["accountCreated", true],
        });
        if (gender === "Female") {
          dispatch({
            type: SET_ONBOARDER,
            payload: ["coins", 25],
          });
        }
      }

      if (ecomm_status === 1 || ecomm_status === 2) {
        dispatch({
          type: SET_ONBOARDER,
          payload: ["accountCreated", true],
        });
        if (gender === "Female") {
          dispatch({
            type: SET_ONBOARDER,
            payload: ["coins", 25],
          });
        }
      }

      dispatch({
        type: SET_ONBOARDER,
        payload: ["gender", gender],
      });
      localStorage.setItem("token", token);
    });
};

export const postGiverOnboardingData = (formData) => {
  return (dispatch, getState) => {
    const token = localStorage.getItem("token");
    return fetch(url.giverOnboardingURL, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json;
        } else {
          throw json;
        }
      });
  };
};

export const getGiverOnboardingData = () => {
  return (dispatch, getState) => {
    const token = localStorage.getItem("token");
    return fetch(url.giverOnboardingURL, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          json.data.age = json.age;
          return json.data;
        } else {
          throw Error(json.message);
        }
      });
  };
};

export const postCouponForGiverOnboarding = (formData) => {
  return (dispatch, getState) => {
    const token = localStorage.getItem("token");
    return fetch(url.couponCheckURL, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          return json.discount;
        } else {
          alert(json.message);
        }
      });
  };
};
